import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { useAuthState } from '@/context';
import { useErrorHandler, useGlobal } from '@/hooks';
import { loadUserService } from '@/services';

export const useAuth = () => {
  const global = useGlobal();
  const [state, setState] = useRecoilState(useAuthState);
  const errorHandler = useErrorHandler();

  const loadUser = () => {
    setState((old) => ({ ...old, loading: true }));

    loadUserService()
      .then((user) => setState((old) => ({ ...old, user, loaded: true })))
      .catch(errorHandler)
      .finally(() => setState((old) => ({ ...old, loading: false })));
  };

  const fillUser = () => {
    if (global?.user?.isFetched) setState((old) => ({ ...old, user: global.user.data, loaded: true }));
    else if (!state.loaded && !state.loading) loadUser();
  };

  useEffect(fillUser, []);

  return state;
};
